/**
 * Fold a label, slug or free-text token to one comparable key:
 * "Mal País" → "mal-pais", "WiFi (Starlink)" → "wifi-starlink", "A/C" → "a-c".
 * Accents dropped, case folded, every run of non-alphanumerics becomes one
 * hyphen. Shared by area matching (browse URLs) and amenity token resolution.
 */
export const foldKey = (s: string): string =>
  String(s ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
